var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tomorrow-icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.9976,
    y1: 12,
    x2: 22,
    y2: 12
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0087FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00CDE9"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#SVGID_1_)",
    d: "M13.9551,8.8687c0.3137-0.0586,0.629-0.1322,0.9368-0.2191 c0.4058-0.1146,0.8089-0.2548,1.1981-0.4168c0.1929-0.0803,0.3864-0.1675,0.575-0.2596c1.1911-0.5799,2.2701-1.3929,3.1883-2.3704 c-0.4936-0.6244-1.0581-1.1881-1.6818-1.6796C16.5635,5.6358,14.3492,6.6325,12,6.6325c-2.3492,0-4.5634-0.9968-6.1716-2.7093 C5.2048,4.4147,4.6401,4.9784,4.1466,5.6028c0.9183,0.9775,1.9973,1.7906,3.1883,2.3704c0.1887,0.092,0.3822,0.1793,0.5749,0.2595 c0.3898,0.1622,0.793,0.3025,1.1983,0.4169c0.3078,0.0869,0.6231,0.1605,0.9368,0.219c0.1056,0.0197,0.2119,0.0378,0.3186,0.0544 c0.2129,0.0331,0.4304,0.0599,0.6463,0.0799C11.6632,9.0636,12.337,9.0635,12.99,9.003c0.2161-0.02,0.4335-0.0469,0.6465-0.08 C13.7432,8.9064,13.8496,8.8883,13.9551,8.8687z M16.1081,2.6668C15.4676,2.3763,14.7924,2.1504,14.0893,2 c-0.6444,0.3488-1.3616,0.5377-2.1096,0.5377c-0.7436,0-1.4569-0.1867-2.0978-0.531c-0.6927,0.1503-1.3583,0.3736-1.99,0.6601 C9.0221,3.6741,10.4736,4.248,12,4.248S14.978,3.6741,16.1081,2.6668z M21.9452,10.4837c-0.1151-0.8115-0.3258-1.5914-0.6189-2.3292 c-4.8248,1.2231-8.3273,5.7089-8.3273,10.9364c0,0.0946,0.0013,0.1887,0.0034,0.2826c0.0215,0.8941,0.1481,1.7724,0.3708,2.6265 c0.7914-0.1094,1.5529-0.3119,2.2745-0.5963c-0.1981-0.7489-0.3015-1.5219-0.3015-2.3128 C15.3462,14.9652,18.1541,11.4239,21.9452,10.4837z M17.6625,19.0908c0,0.3938,0.0408,0.7803,0.1103,1.1603 c0.5793-0.4119,1.114-0.8832,1.5943-1.4066c0.0959-1.5356,0.9252-2.9149,2.1709-3.7075c0.2299-0.701,0.3882-1.4347,0.4621-2.194 C19.4797,13.7977,17.6625,16.2593,17.6625,19.0908z M8.6513,19.0908c0,0.7909-0.1035,1.5639-0.3015,2.3128 C9.0713,21.688,9.8328,21.8906,10.6242,22c0.2227-0.8541,0.3493-1.7324,0.3708-2.6265c0.0021-0.0939,0.0034-0.188,0.0034-0.2826 c0-5.2274-3.5025-9.7132-8.3273-10.9364c-0.2931,0.7378-0.5038,1.5177-0.6189,2.3292C5.8434,11.4239,8.6513,14.9652,8.6513,19.0908z  M1.9976,12.943c0.0738,0.7593,0.2322,1.4931,0.4621,2.194c1.2457,0.7925,2.075,2.1718,2.1709,3.7075 c0.4803,0.5234,1.015,0.9947,1.5943,1.4066c0.0695-0.38,0.1103-0.7665,0.1103-1.1603C6.3351,16.2593,4.5178,13.7977,1.9976,12.943z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9a213050.svg";
export { ForwardRef as ReactComponent };